"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fetchClient_1 = tslib_1.__importDefault(require("../fetchClient/fetchClient"));
const updateSession = async ({ authProxyUrl, additionalHeaders, data }) => {
    try {
        const response = await (0, fetchClient_1.default)(`${authProxyUrl}/api/session`, {
            headers: Object.assign({ 't-target': 'session', 't-credentials': '1' }, additionalHeaders),
            withCredentials: true,
            method: 'put',
            data
        });
        return response === null || response === void 0 ? void 0 : response.data;
    }
    catch (_a) {
        // fail silently, error dealt with in fetchClient
    }
};
exports.default = updateSession;
//# sourceMappingURL=updateSession.js.map